import { Paper, Typography } from '@mui/material';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { DadosPedidoCardRow } from '../../utils/transcricaoDadosPedidoUtils';
import '../../components/TranscricaoRevisao/revisaoSectionCard.css';

interface Props {
  titulo?: string;
  rows: DadosPedidoCardRow[];
}

const TranscricaoDadosPedidoSectionCard: React.FC<Props> = ({ titulo, rows }) => {
  const accessibility = useAccessibility();

  return (
    <section className="transcricao-dados-pedido-section">
      {titulo && (
        <Typography
          component="h3"
          style={accessibility.textStyleAccessibility}
          className="transcricao-dados-pedido-section-title"
        >
          <strong>{titulo}</strong>
        </Typography>
      )}

      <Paper
        className="transcricao-dados-pedido-card"
        elevation={0}
        style={accessibility.contrastBorderAccessibility}
      >
        {rows.map((row, rowIndex) => (
          <div
            key={`${row.fields.map((field) => field.label).join('-')}-${rowIndex}`}
            className={`transcricao-dados-pedido-card-row${
              row.fields.length > 1 ? ' transcricao-dados-pedido-card-row--split' : ''
            }`}
          >
            {row.fields.map((field) => (
              <div key={field.label} className="transcricao-dados-pedido-card-field">
                <span
                  className="transcricao-dados-pedido-card-label"
                  style={accessibility.textStyleAccessibility}
                >
                  {field.label}
                </span>
                <span
                  className="transcricao-dados-pedido-card-value"
                  style={accessibility.textStyleAccessibility}
                >
                  {field.value ?? '—'}
                </span>
              </div>
            ))}
          </div>
        ))}
      </Paper>
    </section>
  );
};

export default TranscricaoDadosPedidoSectionCard;

export type { DadosPedidoCardRow } from '../../utils/transcricaoDadosPedidoUtils';
